'use strict';

// Styles
import 'react-sweet-progress/lib/style.css';
import './index.less';

// Libraries
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

// Components
import BadgeItemTooltip from './BadgeItemTooltip';
import BadgesOverview from './BadgesOverview';
import PageHeader from 'ck-core-client/source/components/Layout/PageHeader';

const BadgesTable = ({ badges, rarities, title, updateSelectedBadge, showTooltip }) => {
	const categories = _.uniq(_.map(badges, 'category'));
	return (
		<div id="TooltipWrapper">
			<div className="BadgesTable">
				{title && <PageHeader subtitle={title} />}
				<BadgesOverview rarities={rarities} badges={badges} />
				{categories &&
					categories.map(category => {
						const categoryBadges = badges.filter(badge => badge.category === category);
						return (
							<div className="badgeRow" key={category}>
								<div className="rowHeader">{category}</div>
								<div className="rowContents">
									<Categories
										rarities={rarities}
										badges={categoryBadges}
										updateSelectedBadge={updateSelectedBadge}
										showTooltip={showTooltip}
									/>
								</div>
							</div>
						);
					})}
			</div>
		</div>
	);
};

const Categories = ({ badges, rarities, updateSelectedBadge, showTooltip }) => {
	return rarities.map(rarity => {
		const currentRarityBadges = badges.filter(badge => badge.rarity === rarity);
		return (
			<div className="cell" key={rarity}>
				{currentRarityBadges.map(badge => (
					<BadgeItemTooltip
						key={badge.badgeId}
						name={badge.name}
						icon={badge.icon}
						badge={badge}
						handleClick={() => {
							updateSelectedBadge && updateSelectedBadge(badge);
						}}
						rarity={badge.rarity}
						unlocked={badge.unlocked}
						recentlyAwarded={badge.recentlyAwarded}
						showTooltip={showTooltip}
					/>
				))}
			</div>
		);
	});
};

export default BadgesTable;

BadgesTable.propTypes = {
	badges: PropTypes.arrayOf(PropTypes.object).isRequired,
	rarities: PropTypes.arrayOf(PropTypes.string.isRequired),
	title: PropTypes.string,
	updateSelectedBadge: PropTypes.func,
	showTooltip: PropTypes.bool
};
